import { render, staticRenderFns } from "./exportlanguages.vue?vue&type=template&id=9d2394f6&"
import script from "./exportlanguages.vue?vue&type=script&lang=js&"
export * from "./exportlanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports